import React from "react";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";

const Landing = ({ data }) => {
  console.log(data);
  return (
    <section className="scroll-section-special py-secondary lg:py-primary lg:-mt-[59vh]">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-16 relative">
          {data?.map(
            ({ title, image, slug, category, date, description }, index) => (
              <Link
                key={index}
                to={`/news/${slug}`}
                className="w-full relative  group"
              >
                <div className="overflow-hidden">
                  <img
                    src={image}
                    alt=""
                    className="w-full object-cover h-[400px] transition ease-in group-hover:scale-[1.05] duration-500"
                  />
                </div>
                <div className="text-white mt-4 capitalize">
                  <p>{category}</p>
                  <p className="text-3xl font-bold text-white z-[10] group-hover:underline">
                    {title}
                  </p>
                  <p className="text-font my-2">{date}</p>
                  {/* <div>
                    <p
                      dangerouslySetInnerHTML={{
                        __html:
                          description.length > 240
                            ? `${description.substring(0, 240)}...`
                            : description,
                      }}
                    />
                  </div> */}
                </div>
              </Link>
            )
          )}
        </div>
      </Container>
    </section>
  );
};

export default Landing;
